import {
  createObjectValidator,
  validateNumber,
  validateString,
  validateUuidV4
} from "../../../../packages/validator/validator.js";
import { ItemAccountEffect, validateItemAccountEffect } from "../item/ItemAccountEffect.js";

/**
 * One item (row) under an account.
 */
export type AccountItem = {
  /**
   * Referenced entry ID.
   */
  entryId: string;
  /**
   * The referenced entry title.
   */
  entryTitle: string;
  /**
   * Item of the referenced entry.
   */
  itemTitle: string;
  /**
   * Item date in string format YYYY-MM-DD.
   */
  itemDate: string;
  /**
   * Whether this item debits or credits to the account.
   */
  itemEffect: ItemAccountEffect;
  /**
   * Amount on the item.
   */
  itemAmount: number;
  /**
   * EUR amount on the item.
   */
  itemEurAmount: number;
  /**
   * Reference to the debit account.
   */
  itemDebit: string;
  /**
   * Reference to the credit account.
   */
  itemCredit: string;
  /**
   * Index of the item in the entry items.
   */
  itemIndex: number;
  /**
   * Actual effect on the account balance.
   */
  change: number;
};

export const validateAccountItem = createObjectValidator<AccountItem>("AccountItem", {
  entryId: validateUuidV4,
  entryTitle: validateString,
  itemTitle: validateString,
  itemDate: validateString,
  itemEffect: validateItemAccountEffect,
  itemAmount: validateNumber,
  itemEurAmount: validateNumber,
  itemDebit: validateUuidV4,
  itemCredit: validateUuidV4,
  itemIndex: validateNumber,
  change: validateNumber
});
